export class SignInRequest {
  email: string;
  password: string;

  constructor() { }
}

export class SignedInUser {
  UserId: number;
  IsAdmin: boolean;
  FirstName: string;
  LastName: string;
  FullName: string;
  AuthenticationToken: string;
  TokenExpiresAt: Date;
  Image: string | null;
  Email: string;
  TwoFactorCode: string;
  Phone: string;
  Roles: string[];

  constructor() { }
}

export class SpecialRoles {
  isAdmin: boolean = false;
  isSuperAdmin: boolean = false;

  constructor() { }
}
